import { APP_TYPE, getAppType, useAppSelector } from '@zonofi/zono-money-store';
import { FIELD_OPS_ROUTES, SELLER_WEBAPP_ROUTES, SESSION } from '../constants';
import { useNavigate } from 'react-router-dom';

export const useCustomNavigate = () => {
  const appType = useAppSelector(getAppType);
  const DEFAULT_ROUTE =
    appType === APP_TYPE.FIELDS_OPS
      ? FIELD_OPS_ROUTES.CUSTOMER_LIST
      : SELLER_WEBAPP_ROUTES.CONVERSATION_LIST;

  const navigate = useNavigate();

  const onBack = (fallback?: string) => {
    const guardUsed = sessionStorage.getItem(SESSION.BACK_GUARD_KEY) === 'true';
    const entrySource = sessionStorage.getItem(SESSION.ENTRY_SOURCE_KEY);
    const canGoBack = window.history.length > 1;

    if (!guardUsed) {
      sessionStorage.setItem(SESSION.BACK_GUARD_KEY, 'true');

      if (entrySource === 'external' || !canGoBack) {
        navigate(fallback || DEFAULT_ROUTE, { replace: true });
        return;
      }
    }
    if (fallback) {
      navigate(fallback);
      return;
    }
    navigate(-1);
  };

  return { navigate, onBack };
};
